<template>
  <div id="container" style="width:100%;height:100%;overflow:hidden;">
  </div>
</template>

<script>

export default {
  props:{
    interPosition:String
  },
  watch:{
    interPosition:{
      immediate:true,
      handler(){
          this.$nextTick(()=>{
            if(!this._panoIns){
              this._panoIns = new pano2vrPlayer("container")
            }
            this._panoIns.readConfigUrlAsync(`inter/${this.interPosition}/${this.interPosition}.xml`)
          })
      }
    }
  }
}
</script>